/** Investor Account */
export class InvestorAccount {
    /** id */
    id: string;
    /** clientID */
    clientID: string;
    /** investorId */
    investorId: string;
    /** isEsignFlag */
    isEsignFlag: string;
    /** iseKYCSubmittedFlag */
    iseKYCSubmittedFlag: string;
    /** isOnBoardFlag */
    isOnBoardFlag: string;
    /** isApprovedFlag */
    isApprovedFlag: string;
    /** esignConsentFlag */
    esignConsentFlag: string;
    /** esignConsentTS */
    esignConsentTS: number;
    /** ipAddress */
    ipAddress: string;
    /** deviceID */
    deviceID: string;
    /** acceptedTC */
    acceptedTC: string;
    /** salesEmpID */
    salesEmpID: string;
    /** referredID */
    referredID: string;
    /** isCommodity */
    isCommodity: string;
    /** isEquity */
    isEquity: string;
    /** coCode */
    coCode: string;
    /** eqCode */
    eqCode: string;
    /** isBackOffice */
    isBackOffice: string;
    /** fcmToken */
    fcmToken: string;
    /** onboardTS */
    onboardTS: string;
    /** approvedTS */
    approvedTS: number;
    /** originalSource */
    originalSource: string;
    /** isFOCAPS */
    isFOCAPS: string;
    /** userType */
    userType: string;
    /** isdfs */
    isdfs: string;
    /** dtExpiry */
    dtExpiry: Date;
    /** dfstage */
    dfstage: string;
    /** isDeleted */
    isDeleted: string;
    /** poa_received */
    poa_received: string;
    /** consent */
    consent: string;
    /** isKYCFlag */
    isKYCFlag: string;
    /** isAadhaarFlag */
    isAadhaarFlag: string;
    /** plan */
    plan: string;
    /** ipvPersonDto */
    ipvPersonDto: IEUINPerson;
    /** euinPersonDto */
    euinPersonDto: IEUINPerson;
    /** leadCity */
    leadCity: string;
    /** invPlan */
    invPlan: string;
    /** isNRI */
    isNRI: string;
    /** isReviewed */
    isReviewed: string;
    /** kraAgent */
    kraAgent: string;
    /** brokerageJson */
    brokerageJson: any;
    /** remark */
    remark: string;
    /** screenName */
    screenName: string;
    /** screenIdentifierId */
    screenIdentifierId: string;
    /** incomeProofImageStatus */
    incomeProofImageStatus: string;
    /** isEmailVerified */
    isEmailVerified: string;
    /** isMobileVerified */
    isMobileVerified: string;
    /** lmsLeadSource */
    lmsLeadSource: string;
    /** pennyFailureCount */
    pennyFailureCount: number;
    /** pennySuccessCount */
    pennySuccessCount: number;
    /** isReferCodeValid */
    isReferCodeValid: string;
    /** leadState */
    leadState: string;
    /** raiseIssueStage */
    raiseIssueStage: string;
    /** issueRaiseGroupId */
    issueRaiseGroupId:string;
    /** isResponded */
    isResponded: string;
    /** isIssueRaise */
    isIssueRaise: string;
    /** esignIssueRaiseStatus */
    esignIssueRaiseStatus: string;
    /** ipvLocation */
    ipvLocation: string;
    /** isDirectPorting */
    isDirectPorting: string;
    /** referralUniqueCode */// 
    referralUniqueCode: string;
    /** ssoSubjectId */
    ssoSubjectId: string;
    /** isDDPIOpted */
    isDDPIOpted: string;
    /** isKraMismatched */
    isKraMismatched: any;
    /** Initializes the component with default values. */
    constructor() {
        this.isEsignFlag = 'N';
        this.iseKYCSubmittedFlag = 'N';
        this.isOnBoardFlag = 'N';
        this.isApprovedFlag = 'N';
        this.esignConsentFlag = 'N';
        this.isCommodity = 'N';
        this.isEquity = 'N';
        this.isBackOffice = 'N';
        this.userType = 'B';
        this.isdfs = 'N';
        this.isDeleted = 'N';
        this.poa_received = 'N';
        this.isKYCFlag = 'N';
        this.isAadhaarFlag = 'N';
        this.ipvPersonDto = null;
        this.euinPersonDto = null;
        this.isNRI = 'N';
        this.isReviewed = 'N';
        this.consent = 'N';
        this.brokerageJson = null;
        this.remark = null;
        this.isReferCodeValid = 'N';
        this.isEmailVerified = 'N';
        this.isMobileVerified = 'N';
        this.pennyFailureCount = 0;
        this.pennySuccessCount = 0;
        this.isResponded='N';
    }
}

/** IPV Person Detail */
export interface IPVPerson {
    /** id */
    id?: string;
    /** empName */
    empName?: string;
    /** empCode */
    empCode?: string;
    /** empDesg */
    empDesg?: string;
    /** empBranch */
    empBranch?: string;
    /** empEmailID */
    empEmailID?: string;
    /** empMobileNo */
    empMobileNo?: string;
    /** company */
    company?: string;
    /** ipvCount */
    ipvCount?: string;
}

/** IEUIN Person Detail */
export interface IEUINPerson {
    /** id */
    id?: string;
    /** empName */
    empName?: string;
    /** euinNo */
    euinNo?: string;
    /** euinCount */
    euinCount?: string;
}
